import React, { useEffect } from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { communicationHistory, getDownloadEmail, resendMailSms } from "../../../services/insurance/correspondence"
import { timeConvert } from "../../../services/insurance/common";
import CircularProgress from '@mui/material/CircularProgress';
import { useAxiosLoader } from '../../../plugins/axios'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

export default function ShowCommunicationHistory(props) {
    const [loading] = useAxiosLoader();
    const [details] = React.useState(props.details);
    const [communcation, setcommuncation] = React.useState([]);
    const [resend, setResend] = React.useState(undefined);
    const [phone, setPhone] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [errMsg,setErrMsg] = React.useState("");

    useEffect(() => {
        let isMounted = true;
        if(isMounted){
            communicationHistory(details && details.id?details.id:details.customerDetails.requestID).then(res => {
                res.communicationDetails.map(ele => ele.url = getDownloadEmail(ele.messageId));
                setcommuncation(res.communicationDetails)
            });
        }
        return () => { isMounted = false };
    }, [details])

    const  handleChange =(e) =>{
        if(resend && resend != {}){
            if(resend.type === "mail"){
                setEmail(e.target.value)
            }
            else{
                setPhone(e.target.value)
            }
        }
    }

    const resendMsgMail = () => {
        const data = {
            "requestId":details.id?details.id:details.customerDetails?details.customerDetails.requestID:null,
            "emailAddress": email,
            "mobile": phone,
            "statusId": resend.status,
            "emailAuditLogId": resend.id,
        }
        resendMailSms(data)
        .then(res=>{
            if(res.isSuccess)
                setResend(undefined);
            else{
                setErrMsg(res.errorMessage)
            }
        })
        .catch(err=>{
            setErrMsg("Unable to send")
        })
    }

    return (
        <div>
            {loading ?
                <div className="m-auto text-center pt-4">
                    <CircularProgress />
                </div> :
                <Timeline position="alternate">
                    {
                        communcation && communcation.length > 0 ? communcation.map((elem, index) => (

                            <TimelineItem key={index}>
                                <TimelineOppositeContent color="text.secondary">
                                    <div className="text-sm">
                                    {new Date(elem.communicationSentDate).toDateString()} {timeConvert(new Date(elem.communicationSentDate).toLocaleTimeString())} 
                                    {elem.isDelivered ? 
                                        <div className="pt-2">
                                            <span className="bg-green-500 rounded px-2 py-1 text-xs text-gray-100">
                                              DELIVERED
                                            </span>
                                        </div>
                                    : ''}

                                    
                                    </div>
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot variant="outlined" color={index === 0 ? "success" : 'primary'} />
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <div className={(index % 2 === 1) ? "corr-card-design-2 rounded-lg shadow-lg  px-6 py-4" : "corr-card-design-1 rounded-lg shadow-lg  px-6 py-4"}>
                                        <div className="font-semibold">
                                            {elem.currentStatus} {elem.communicationTypeValue} to {elem.reciever}
                                        </div>
                                       <div>
                                           <span className="text-sm">
                                           {elem.body}
                                           </span>
                                       </div>
                                    </div>
                                    {
                                        elem.isDelivered && elem.communicationTypeValue === 'Email' &&
                                    <div className="pt-2">
                                            <a href={elem.url} download >
                                        <span className="bg-blue-500 rounded px-2 py-1 mr-3 text-xs text-gray-100">
                                          Download Email
                                        </span>
                                        </a>
                                        <span className="bg-blue-500 rounded px-2 py-1 text-xs text-gray-100 cursor-pointer" onClick={()=>{setResend({send:true,type:"mail",status:elem.status,id:elem.id})}} >
                                          Resend Email
                                        </span>
                                    </div>
                                    }
                                    {
                                        elem.isDelivered && elem.communicationTypeValue === 'SMS' && 
                                    <div className="pt-2">
                                        <span className="bg-blue-500 rounded px-2 py-1 text-xs text-gray-100 cursor-pointer" onClick={()=>{setResend({send:true,type:"sms",status:elem.status,id:elem.id})}} >
                                          Resend Sms
                                        </span>
                                    </div>
                                    }

                                </TimelineContent>
                            </TimelineItem>


                        )) : <div className="text-center font-semibold text-gray-600 pt-2">
                            <span className="bg-red-100 rounded p-2">
                                Communication history is not available
                            </span>
                        </div>
                    }

                </Timeline>
            }

            <Dialog open={resend && resend != {}} onClose={()=>setResend(undefined)}>
              <DialogTitle>
                {
                    resend && resend !== {} && resend.type === "mail" ? "Enter E-Mail" : "Enter Phone Number"
                }
              </DialogTitle>
              <DialogContent>
                <DialogContentText className='py-3'>
                  <TextField
                    id="email/Phone"
                    type={resend && resend != {} && resend.type === "mail" ? "email" : "number"}
                    label={resend && resend != {} && resend.type === "mail" ? "E-Mail" : "Phone Number"}
                    value={resend && resend != {} && resend.type === "mail" ? email : phone}
                    onChange={(e)=>handleChange(e)}
                  />
                  
                  { errMsg && <Typography variant="subtitle2" color="red">{errMsg}</Typography> }
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={()=>setResend(undefined)}
                  color="secondary"
                >
                  Cancel
                </Button>
                <Button
                  onClick={()=>resendMsgMail()}
                  color="primary"
                >
                  Resend
                </Button>
              </DialogActions>
            </Dialog>
        </div>
    );
}